import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import Paragraph from '../Paragraph';
import Divider from './Divider';
import SuccessMessage from './SuccessMessage';

const Header: FC = () => {
  const { t } = useTranslation(['property']);

  return (
    <div>
      <SuccessMessage />
      <Divider />
      <Paragraph>
        {t('property:relatedPropertiesSuccessModalParagraph')}
      </Paragraph>
    </div>
  );
};

export default Header;
